import { Props } from '~/containers/QuoteEstimates';
import { isAutoOnlyMediaAlphaActivated } from '~/util/optimizelyHelpers';

const step = {
  route: '/homeowners-insurance/quotes/estimates',
  isAccessible: ({ application: { automateQuoteEligibility, isAutoOnly } }: Props) => {
    const isAutoOnlyMediaAlphaExperiment = isAutoOnly && isAutoOnlyMediaAlphaActivated();

    return automateQuoteEligibility === 'eligible' && !isAutoOnlyMediaAlphaExperiment;
  },
  breadcrumbStep: 'property',
};

export default step;
